var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-dropdown-menu',{staticClass:"lang-menu",attrs:{"direction":"up"}},[_c('van-dropdown-item',{attrs:{"options":_vm.columns},on:{"change":_vm.handleSetLanguage},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }